export const AppHeaderHeight = 72;
export const AppHeaderHeightSm = 64;
export const AppFooterHeight = 32;
export const AppFooterHeightSm = 64;
export const AppMainContentPadding = 60;
export const InBuildAppHeaderHeight = 70;

export const InBuildAppSidebarHeaderHeight = 86;
export const MailAppContentHeaderHeight = 78;

export const TaskDetailHeaderHeight = 72;
export const TaskDetailAddCommentHeight = 72;

export const ChatSidebarHeaderHeight = 124;
export const ChatSidebarTabContainerHeight = 49;
export const ChatFooterHeight = 70;
export const CurrentAuthMethod = 'jwtAuth'; //jwtAuth,firebase,basic

export const getAppSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppHeaderHeight : 0)
      );
  }
};

export const getMailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getContactContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskDetailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getWallHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const countriesHR = [
  { name: 'AFGANISTAN                         ', code: 'AFG' },
  { name: 'ALBANIJA                           ', code: 'ALB' },
  { name: 'ALŽIR                              ', code: 'DZA' },
  { name: 'AMERIČKA SAMOA                     ', code: 'ASM' },
  { name: 'AMERIČKI DJEVIČANSKI OTOCI         ', code: 'VIR' },
  { name: 'ANDORA                             ', code: 'AND' },
  { name: 'ANGOLA                             ', code: 'AGO' },
  { name: 'ANGUILLA                           ', code: 'AIA' },
  { name: 'ANTARKTIKA                         ', code: 'ATA' },
  { name: 'ANTIGVA I BARBUDA                  ', code: 'ATG' },
  { name: 'ARGENTINA                          ', code: 'ARG' },
  { name: 'ARMENIJA                           ', code: 'ARM' },
  { name: 'ARUBA                              ', code: 'ABW' },
  { name: 'AUSTRALIJA                         ', code: 'AUS' },
  { name: 'AUSTRIJA                           ', code: 'AUT' },
  { name: 'AZERBAJDŽAN                        ', code: 'AZE' },
  { name: 'BAHAMI                             ', code: 'BHS' },
  { name: 'BAHREIN                            ', code: 'BHR' },
  { name: 'BANGLADEŠ                          ', code: 'BGD' },
  { name: 'BARBADOS                           ', code: 'BRB' },
  { name: 'BELGIJA                            ', code: 'BEL' },
  { name: 'BELIZE                             ', code: 'BLZ' },
  { name: 'BENIN                              ', code: 'BEN' },
  { name: 'BERMUDI                            ', code: 'BMU' },
  { name: 'BJELOKOSNA OBALA                   ', code: 'CIV' },
  { name: 'BJELORUSIJA                        ', code: 'BLR' },
  { name: 'BOCVANA                            ', code: 'BWA' },
  { name: 'BOLIVIJA                           ', code: 'BOL' },
  { name: 'BOSNA I HERCEGOVINA                ', code: 'BIH' },
  { name: 'BOŽIĆNI OTOK                       ', code: 'CXR' },
  { name: 'BRAZIL                             ', code: 'BRA' },
  { name: 'BRITANSKI DJEVIČANSKI OTOCI        ', code: 'VGB' },
  { name: 'BRUNEJ                             ', code: 'BRN' },
  { name: 'BUGARSKA                           ', code: 'BGR' },
  { name: 'BURKINA FASO                       ', code: 'BFA' },
  { name: 'BURUNDI                            ', code: 'BDI' },
  { name: 'BUTAN                              ', code: 'BTN' },
  { name: 'CAPE VERDE                         ', code: 'CPV' },
  { name: 'CIPAR                              ', code: 'CYP' },
  { name: 'CRNA GORA                          ', code: 'MNE' },
  { name: 'ČAD                                ', code: 'TCD' },
  { name: 'ČEŠKA                              ', code: 'CZE' },
  { name: 'ČILE                               ', code: 'CHL' },
  { name: 'DANSKA                             ', code: 'DNK' },
  { name: 'DOMINIKA                           ', code: 'DMA' },
  { name: 'DOMINIKANSKA REPUBLIKA             ', code: 'DOM' },
  { name: 'DŽIBUTI                            ', code: 'DJI' },
  { name: 'EGIPAT                             ', code: 'EGY' },
  { name: 'EKVADOR                            ', code: 'ECU' },
  { name: 'EKVATORSKA GVINEJA                 ', code: 'GNQ' },
  { name: 'ERITREJA                           ', code: 'ERI' },
  { name: 'ESTONIJA                           ', code: 'EST' },
  { name: 'ETIOPIJA                           ', code: 'ETH' },
  { name: 'FALKLANDI (MALVINI)                ', code: 'FLK' },
  { name: 'FEROJSKI (OVČJI) OTOCI             ', code: 'FRO' },
  { name: 'FIDŽI                              ', code: 'FJI' },
  { name: 'FILIPINI                           ', code: 'PHL' },
  { name: 'FINSKA                             ', code: 'FIN' },
  { name: 'FRANCUSKA                          ', code: 'FRA' },
  { name: 'FRANCUSKA GVAJANA                  ', code: 'GUF' },
  { name: 'FRANCUSKA POLINEZIJA               ', code: 'PYF' },
  { name: 'FRANCUSKI JUŽNI TERITORIJI         ', code: 'ATF' },
  { name: 'GABON                              ', code: 'GAB' },
  { name: 'GAMBIJA                            ', code: 'GMB' },
  { name: 'GANA                               ', code: 'GHA' },
  { name: 'GIBRALTAR                          ', code: 'GIB' },
  { name: 'GRČKA                              ', code: 'GRC' },
  { name: 'GRENADA                            ', code: 'GRD' },
  { name: 'GRENLAND                           ', code: 'GRL' },
  { name: 'GRUZIJA                            ', code: 'GEO' },
  { name: 'GUADELOUPE                         ', code: 'GLP' },
  { name: 'GUAM                               ', code: 'GUM' },
  { name: 'GUERNSEY                           ', code: 'GGY' },
  { name: 'GVAJANA                            ', code: 'GUY' },
  { name: 'GVATEMALA                          ', code: 'GTM' },
  { name: 'GVINEJA                            ', code: 'GIN' },
  { name: 'GVINEJA BISAU                      ', code: 'GNB' },
  { name: 'HAITI                              ', code: 'HTI' },
  { name: 'HONDURAS                           ', code: 'HND' },
  { name: 'HONG KONG                          ', code: 'HKG' },
  { name: 'HRVATSKA                           ', code: 'HRV' },
  { name: 'INDIJA                             ', code: 'IND' },
  { name: 'INDONEZIJA                         ', code: 'IDN' },
  { name: 'IRAK                               ', code: 'IRQ' },
  { name: 'IRAN                               ', code: 'IRN' },
  { name: 'IRSKA                              ', code: 'IRL' },
  { name: 'ISLAND                             ', code: 'ISL' },
  { name: 'ITALIJA                            ', code: 'ITA' },
  { name: 'IZRAEL                             ', code: 'ISR' },
  { name: 'JAMAJKA                            ', code: 'JAM' },
  { name: 'JAPAN                              ', code: 'JPN' },
  { name: 'JEMEN                              ', code: 'YEM' },
  { name: 'JERSEY                             ', code: 'JEY' },
  { name: 'JORDAN                             ', code: 'JOR' },
  { name: 'JUŽNOAFRIČKA                       ', code: 'ZAF' },
  { name: 'KAJMANSKI OTOCI                    ', code: 'CYM' },
  { name: 'KAMBODŽA                           ', code: 'KHM' },
  { name: 'KAMERUN                            ', code: 'CMR' },
  { name: 'KANADA                             ', code: 'CAN' },
  { name: 'KATAR                              ', code: 'QAT' },
  { name: 'KAZAHSTAN                          ', code: 'KAZ' },
  { name: 'KENIJA                             ', code: 'KEN' },
  { name: 'KINA                               ', code: 'CHN' },
  { name: 'KIRGISTAN                          ', code: 'KGZ' },
  { name: 'KIRIBATI                           ', code: 'KIR' },
  { name: 'KOKOSOVI OTOCI                     ', code: 'CCK' },
  { name: 'KOLUMBIJA                          ', code: 'COL' },
  { name: 'KOMORI                             ', code: 'COM' },
  { name: 'KONGO                              ', code: 'COG' },
  { name: 'KONGO, DEMOKRATSKA REPUBLIKA       ', code: 'COD' },
  { name: 'KOREJA, SJEVERNA                   ', code: 'PRK' },
  { name: 'KOREJA, JUŽNA                      ', code: 'KOR' },
  { name: 'KOSOVO                             ', code: 'XKX' },
  { name: 'KOSTARIKA                          ', code: 'CRI' },
  { name: 'KUBA                               ', code: 'CUB' },
  { name: 'KUKOVI OTOCI                       ', code: 'COK' },
  { name: 'KUVAJT                             ', code: 'KWT' },
  { name: 'LAOS                               ', code: 'LAO' },
  { name: 'LESOTO                             ', code: 'LSO' },
  { name: 'LETONIJA                           ', code: 'LVA' },
  { name: 'LIBANON                            ', code: 'LBN' },
  { name: 'LIBERIJA                           ', code: 'LBR' },
  { name: 'LIBIJA                             ', code: 'LBY' },
  { name: 'LIHTENŠTAJN                        ', code: 'LIE' },
  { name: 'LITVA                              ', code: 'LTU' },
  { name: 'LUKSEMBURG                         ', code: 'LUX' },
  { name: 'MADAGASKAR                         ', code: 'MDG' },
  { name: 'MADŽARSKA                          ', code: 'HUN' },
  { name: 'MAKAO                              ', code: 'MAC' },
  { name: 'MAKEDONIJA                         ', code: 'MKD' },
  { name: 'MALAVI                             ', code: 'MWI' },
  { name: 'MALDIVI                            ', code: 'MDV' },
  { name: 'MALEZIJA                           ', code: 'MYS' },
  { name: 'MALI                               ', code: 'MLI' },
  { name: 'MALTA                              ', code: 'MLT' },
  { name: 'MAROKO                             ', code: 'MAR' },
  { name: 'MARŠALOVI OTOCI                    ', code: 'MHL' },
  { name: 'MARTINIQUE                         ', code: 'MTQ' },
  { name: 'MAURICIJUS                         ', code: 'MUS' },
  { name: 'MAURITANIJA                        ', code: 'MRT' },
  { name: 'MAYOTTE                            ', code: 'MYT' },
  { name: 'MEKSIKO                            ', code: 'MEX' },
  { name: 'MIJANMAR                           ', code: 'MMR' },
  { name: 'MIKRONEZIJA                        ', code: 'FSM' },
  { name: 'MOLDAVIJA                          ', code: 'MDA' },
  { name: 'MONAKO                             ', code: 'MCO' },
  { name: 'MONGOLIJA                          ', code: 'MNG' },
  { name: 'MONTSERRAT                         ', code: 'MSR' },
  { name: 'MOZAMBIK                           ', code: 'MOZ' },
  { name: 'NAMIBIJA                           ', code: 'NAM' },
  { name: 'NAURU                              ', code: 'NRU' },
  { name: 'NEPAL                              ', code: 'NPL' },
  { name: 'NIGER                              ', code: 'NER' },
  { name: 'NIGERIJA                           ', code: 'NGA' },
  { name: 'NIKARAGVA                          ', code: 'NIC' },
  { name: 'NIUE                               ', code: 'NIU' },
  { name: 'NIZOZEMSKA                         ', code: 'NLD' },
  { name: 'NORVEŠKA                           ', code: 'NOR' },
  { name: 'NOVA KALEDONIJA                    ', code: 'NCL' },
  { name: 'NOVI ZELAND                        ', code: 'NZL' },
  { name: 'NJEMAČKA                           ', code: 'DEU' },
  { name: 'OMAN                               ', code: 'OMN' },
  { name: 'OTOCI TURKS I CAICOS               ', code: 'TCA' },
  { name: 'OTOK BOUVET                        ', code: 'BVT' },
  { name: 'OTOK HEARD I OTOCI MCDONALD        ', code: 'HMD' },
  { name: 'OTOK MAN                           ', code: 'IMN' },
  { name: 'OTOK NORFOLK                       ', code: 'NFK' },
  { name: 'PAKISTAN                           ', code: 'PAK' },
  { name: 'PALAU                              ', code: 'PLW' },
  { name: 'PALESTINSKO PODRUČJE               ', code: 'PSE' },
  { name: 'PANAMA                             ', code: 'PAN' },
  { name: 'PAPUA NOVA GVINEJA                 ', code: 'PNG' },
  { name: 'PARAGVAJ                           ', code: 'PRY' },
  { name: 'PERU                               ', code: 'PER' },
  { name: 'PITCAIRN                           ', code: 'PCN' },
  { name: 'POLJSKA                            ', code: 'POL' },
  { name: 'PORTORIKO                          ', code: 'PRI' },
  { name: 'PORTUGAL                           ', code: 'PRT' },
  { name: 'RÉUNION                            ', code: 'REU' },
  { name: 'RUANDA                             ', code: 'RWA' },
  { name: 'RUMUNJSKA                          ', code: 'ROU' },
  { name: 'RUSIJA                             ', code: 'RUS' },
  { name: 'SAD                                ', code: 'USA' },
  { name: 'SALVADOR                           ', code: 'SLV' },
  { name: 'SAMOA                              ', code: 'WSM' },
  { name: 'SAN MARINO                         ', code: 'SMR' },
  { name: 'SAUDIJSKA ARABIJA                  ', code: 'SAU' },
  { name: 'SEJŠELI                            ', code: 'SYC' },
  { name: 'SENEGAL                            ', code: 'SEN' },
  { name: 'SIJERA LEONE                       ', code: 'SLE' },
  { name: 'SINGAPUR                           ', code: 'SGP' },
  { name: 'SIRIJA                             ', code: 'SYR' },
  { name: 'SJEVERNI MARIJANSKI OTOCI          ', code: 'MNP' },
  { name: 'SLOVAČKA                           ', code: 'SVK' },
  { name: 'SLOVENIJA                          ', code: 'SVN' },
  { name: 'SOLOMONSKI OTOCI                   ', code: 'SLB' },
  { name: 'SOMALIJA                           ', code: 'SOM' },
  { name: 'SRBIJA                             ', code: 'SRB' },
  { name: 'SREDNJOAFRIČKA REPUBLIKA           ', code: 'CAF' },
  { name: 'SUDAN                              ', code: 'SDN' },
  { name: 'SURINAM                            ', code: 'SUR' },
  { name: 'SVALBARD I JAN MAYEN               ', code: 'SJM' },
  { name: 'SVAZI                              ', code: 'SWZ' },
  { name: 'SVETA HELENA, ASCENSION I TRISTAN  ', code: 'SHN' },
  { name: 'SVETA LUCIJA                       ', code: 'LCA' },
  { name: 'SVETI BARTOLOMEJ                   ', code: 'BLM' },
  { name: 'VATIKAN, SVETA STOLICA             ', code: 'VAT' },
  { name: 'SVETI KRISTOFOR I NEVIS            ', code: 'KNA' },
  { name: 'SVETI MARTIN                       ', code: 'MAF' },
  { name: 'SVETI PETAR I MIKELON              ', code: 'SPM' },
  { name: 'SVETI TOMA I PRINSIPE              ', code: 'STP' },
  { name: 'SVETI VINCENT I GRENADINI          ', code: 'VCT' },
  { name: 'ŠPANJOLSKA                         ', code: 'ESP' },
  { name: 'ŠRI LANKA                          ', code: 'LKA' },
  { name: 'ŠVEDSKA                            ', code: 'SWE' },
  { name: 'ŠVICARSKA                          ', code: 'CHE' },
  { name: 'TADŽIKISTAN                        ', code: 'TJK' },
  { name: 'TAJLAND                            ', code: 'THA' },
  { name: 'TAJVAN, KINESKI                    ', code: 'TWN' },
  { name: 'TANZANIJA                          ', code: 'TZA' },
  { name: 'TIMOR LESTE                        ', code: 'TLS' },
  { name: 'TOGO                               ', code: 'TGO' },
  { name: 'TOKELAU                            ', code: 'TKL' },
  { name: 'TONGA                              ', code: 'TON' },
  { name: 'TRINIDAD I TOBAGO                  ', code: 'TTO' },
  { name: 'TUNIS                              ', code: 'TUN' },
  { name: 'TURKMENISTAN                       ', code: 'TKM' },
  { name: 'TURSKA                             ', code: 'TUR' },
  { name: 'TUVALU                             ', code: 'TUV' },
  { name: 'UGANDA                             ', code: 'UGA' },
  { name: 'UJEDINJENI ARAPSKI EMIRATI         ', code: 'ARE' },
  { name: 'UKRAJINA                           ', code: 'UKR' },
  { name: 'URUGVAJ                            ', code: 'URY' },
  { name: 'UZBEKISTAN                         ', code: 'UZB' },
  { name: 'VANUATU                            ', code: 'VUT' },
  { name: 'VELIKA BRITANIJA                   ', code: 'GBR' },
  { name: 'VENEZUELA                          ', code: 'VEN' },
  { name: 'VIJETNAM                           ', code: 'VNM' },
  { name: 'WALLIS I FUTUNA                    ', code: 'WLF' },
  { name: 'ZAMBIJA                            ', code: 'ZMB' },
  { name: 'ZAPADNA SAHARA                     ', code: 'ESH' },
  { name: 'ZIMBABVE                           ', code: 'ZWE' },
];

export const countriesEN = [
  { name: 'AFGHANISTAN', code: 'AFG' },
  { name: 'ALBANIA', code: 'ALB' },
  { name: 'ALGERIA', code: 'DZA' },
  { name: 'AMERICAN SAMOA', code: 'ASM' },
  { name: 'AMERICAN VIRGIN ISLANDS', code: 'VIR' },
  { name: 'ANDORRA', code: 'AND' },
  { name: 'ANGOLA', code: 'AGO' },
  { name: 'ANGUILLA', code: 'AIA' },
  { name: 'ANTARCTICA', code: 'ATA' },
  { name: 'ANTIGUA AND BARBUDA', code: 'ATG' },
  { name: 'ARGENTINA', code: 'ARG' },
  { name: 'ARMENIA', code: 'ARM' },
  { name: 'ARUBA', code: 'ABW' },
  { name: 'AUSTRALIA', code: 'AUS' },
  { name: 'AUSTRIA', code: 'AUT' },
  { name: 'AZERBAIJAN', code: 'AZE' },
  { name: 'BAHAMAS', code: 'BHS' },
  { name: 'BAHRAIN', code: 'BHR' },
  { name: 'BANGLADESH', code: 'BGD' },
  { name: 'BARBADOS', code: 'BRB' },
  { name: 'BELARUS', code: 'BLR' },
  { name: 'BELGIUM', code: 'BEL' },
  { name: 'BELIZE', code: 'BLZ' },
  { name: 'BENIN', code: 'BEN' },
  { name: 'BERMUDA', code: 'BMU' },
  { name: 'BOLIVIA', code: 'BOL' },
  { name: 'BOSNIA AND HERZEGOVINA', code: 'BIH' },
  { name: 'BOTSWANA', code: 'BWA' },
  { name: 'BOUVET ISLAND', code: 'BVT' },
  { name: 'BRAZIL', code: 'BRA' },
  { name: 'BRITISH VIRGIN ISLANDS', code: 'VGB' },
  { name: 'BRUNEI', code: 'BRN' },
  { name: 'BULGARIA', code: 'BGR' },
  { name: 'BURKINA FASO', code: 'BFA' },
  { name: 'BURUNDI', code: 'BDI' },
  { name: 'BUTANE', code: 'BTN' },
  { name: 'CAMBODIA', code: 'KHM' },
  { name: 'CAMEROON', code: 'CMR' },
  { name: 'CANADA', code: 'CAN' },
  { name: 'CAPE VERDE', code: 'CPV' },
  { name: 'QATAR', code: 'QAT' },
  { name: 'CAYMAN ISLANDS', code: 'CYM' },
  { name: 'CENTRAL AFRICAN REPUBLIC', code: 'CAF' },
  { name: 'CHAD', code: 'TCD' },
  { name: 'CHAMBER', code: 'COM' },
  { name: 'CHILE', code: 'CHL' },
  { name: 'CHINA', code: 'CHN' },
  { name: 'CHRISTMAS ISLAND', code: 'CXR' },
  { name: 'COCONUT ISLANDS', code: 'CCK' },
  { name: 'COLOMBIA', code: 'COL' },
  { name: 'CONGO', code: 'COG' },
  { name: 'CONGO, DEMOCRATIC REPUBLIC', code: 'COD' },
  { name: 'COSTA RICA', code: 'CRI' },
  { name: 'CUBA', code: 'CUB' },
  { name: 'CROATIA', code: 'HRV' },
  { name: 'CYPRUS', code: 'CYP' },
  { name: 'CZECH REPUBLIC', code: 'CZE' },
  { name: 'DENMARK', code: 'DNK' },
  { name: 'Djibouti', code: 'DJI' },
  { name: 'DOMINICA', code: 'DMA' },
  { name: 'DOMINICAN REPUBLIC', code: 'DOM' },
  { name: 'ECUADOR', code: 'ECU' },
  { name: 'EGYPT', code: 'EGY' },
  { name: 'EQUATORIAL GUINEA', code: 'GNQ' },
  { name: 'ERITREA', code: 'ERI' },
  { name: 'ESTONIA', code: 'EST' },
  { name: 'ETHIOPIA', code: 'ETH' },
  { name: 'FAIRY (SHEEP) ISLANDS', code: 'FRO' },
  { name: 'FALKLANDS (MALVINI)', code: 'FLK' },
  { name: 'FIJI', code: 'FJI' },
  { name: 'FINLAND', code: 'FIN' },
  { name: 'FRANCE', code: 'FRA' },
  { name: 'FRENCH GUYANA', code: 'GUF' },
  { name: 'FRENCH POLYNESIA', code: 'PYF' },
  { name: 'FRENCH SOUTHERN TERRITORIES', code: 'ATF' },
  { name: 'GABON', code: 'GAB' },
  { name: 'GAMBIA', code: 'GMB' },
  { name: 'GEORGIA', code: 'GEO' },
  { name: 'GERMANY', code: 'DEU' },
  { name: 'GHANA', code: 'GHA' },
  { name: 'GIBRALTAR', code: 'GIB' },
  { name: 'GREAT BRITAIN', code: 'GBR' },
  { name: 'GREECE', code: 'GRC' },
  { name: 'GREENLAND', code: 'GRL' },
  { name: 'GRENADE', code: 'GRD' },
  { name: 'GUADELOUPE', code: 'GLP' },
  { name: 'GUAM', code: 'GUM' },
  { name: 'GUATEMALA', code: 'GTM' },
  { name: 'GUERNSEY', code: 'GGY' },
  { name: 'GUINEA', code: 'GIN' },
  { name: 'GUINEA BISAU', code: 'GNB' },
  { name: 'GUYANA', code: 'GUY' },
  { name: 'HAITI', code: 'HTI' },
  { name: 'HEARD ISLAND AND MCDONALD ISLANDS', code: 'HMD' },
  { name: 'HONDURAS', code: 'HND' },
  { name: 'HONG KONG', code: 'HKG' },
  { name: 'HOOK ISLANDS', code: 'COK' },
  { name: 'HUNGARY', code: 'HUN' },
  { name: 'ICELAND', code: 'ISL' },
  { name: 'INDIA', code: 'IND' },
  { name: 'INDONESIA', code: 'IDN' },
  { name: 'IRAN', code: 'IRN' },
  { name: 'IRAQ', code: 'IRQ' },
  { name: 'IRELAND', code: 'IRL' },
  { name: 'ISLAND OF MAN', code: 'IMN' },
  { name: 'ISRAEL', code: 'ISR' },
  { name: 'ITALY', code: 'ITA' },
  { name: 'Ivory Coast', code: 'CIV' },
  { name: 'JAMAICA', code: 'JAM' },
  { name: 'JAPAN', code: 'JPN' },
  { name: 'JERSEY', code: 'JEY' },
  { name: 'JORDAN', code: 'JOR' },
  { name: 'KAZAKHSTAN', code: 'KAZ' },
  { name: 'KENYA', code: 'KEN' },
  { name: 'KIRIBATI', code: 'KIR' },
  { name: 'KOREA, NORTH', code: 'PRK' },
  { name: 'KOREA, SOUTH', code: 'KOR' },
  { name: 'KOSOVO', code: 'XKX' },
  { name: 'KUWAIT', code: 'KWT' },
  { name: 'KYRGYZSTAN', code: 'KGZ' },
  { name: 'LAOS', code: 'LAO' },
  { name: 'LATVIA', code: 'LVA' },
  { name: 'LEBANON', code: 'LBN' },
  { name: 'LESOTHO', code: 'LSO' },
  { name: 'LIBERIA', code: 'LBR' },
  { name: 'LIBYA', code: 'LBY' },
  { name: 'LIECHTENSTEIN', code: 'LIE' },
  { name: 'LITHUANIA', code: 'LTU' },
  { name: 'LITTLE', code: 'MLI' },
  { name: 'LUXEMBOURG', code: 'LUX' },
  { name: 'MACEDONIA', code: 'MKD' },
  { name: 'MADAGASCAR', code: 'MDG' },
  { name: 'MAKAO', code: 'MAC' },
  { name: 'MALAWI', code: 'MWI' },
  { name: 'MALAYSIA', code: 'MYS' },
  { name: 'MALDIVES', code: 'MDV' },
  { name: 'MALTA', code: 'MLT' },
  { name: 'MARSHAL ISLANDS', code: 'MHL' },
  { name: 'MARTINIQUE', code: 'MTQ' },
  { name: 'MAURITANIA', code: 'MRT' },
  { name: 'MAURITIUS', code: 'MUS' },
  { name: 'MAYOTTE', code: 'MYT' },
  { name: 'MEXICO', code: 'MEX' },
  { name: 'MICRONESIA', code: 'FSM' },
  { name: 'MOLDOVA', code: 'MDA' },
  { name: 'MONACO', code: 'MCO' },
  { name: 'MONGOLIA', code: 'MNG' },
  { name: 'MONTENEGRO', code: 'MNE' },
  { name: 'MONTSERRAT', code: 'MSR' },
  { name: 'MOROCCO', code: 'MAR' },
  { name: 'MOZAMBIQUE', code: 'MOZ' },
  { name: 'MYANMAR', code: 'MMR' },
  { name: 'NAMIBIA', code: 'NAM' },
  { name: 'NAURU', code: 'NRU' },
  { name: 'NEPAL', code: 'NPL' },
  { name: 'NETHERLANDS', code: 'NLD' },
  { name: 'NEW', code: 'NIU' },
  { name: 'NEW CALEDONIA', code: 'NCL' },
  { name: 'NEW ZEALAND', code: 'NZL' },
  { name: 'NICARAGUA', code: 'NIC' },
  { name: 'NIGER', code: 'NER' },
  { name: 'NIGERIA', code: 'NGA' },
  { name: 'NORFOLK ISLAND', code: 'NFK' },
  { name: 'NORTHERN MARIAN ISLANDS', code: 'MNP' },
  { name: 'NORWAY', code: 'NOR' },
  { name: 'OMAN', code: 'OMN' },
  { name: 'PAKISTAN', code: 'PAK' },
  { name: 'PALAU', code: 'PLW' },
  { name: 'PALESTINIAN AREA', code: 'PSE' },
  { name: 'PANAMA', code: 'PAN' },
  { name: 'PAPUA NEW GUINEA', code: 'PNG' },
  { name: 'PARAGUAY', code: 'PRY' },
  { name: 'PERU', code: 'PER' },
  { name: 'PHILIPPINES', code: 'PHL' },
  { name: 'PITCAIRN', code: 'PCN' },
  { name: 'POLAND', code: 'POL' },
  { name: 'PORTUGAL', code: 'PRT' },
  { name: 'PUERTO RICO', code: 'PRI' },
  { name: 'REUNION', code: 'REU' },
  { name: 'ROMANIA', code: 'ROU' },
  { name: 'RUSSIA', code: 'RUS' },
  { name: 'RWANDA', code: 'RWA' },
  { name: 'SAINT BARTHOLOMEW', code: 'BLM' },
  { name: 'SAINT CHRISTOPHER AND NEVIS', code: 'KNA' },
  { name: 'SAINT HELENA, ASCENSION AND TRISTAN', code: 'SHN' },
  { name: 'SAINT LUCIA', code: 'LCA' },
  { name: 'SAINT MARTIN', code: 'MAF' },
  { name: 'SAINT PETER AND MICHELON', code: 'SPM' },
  { name: 'SAINT TOMA AND PRINCIPE', code: 'STP' },
  { name: 'SAINT VINCENT AND THE Grenadines', code: 'VCT' },
  { name: 'SALVADOR', code: 'SLV' },
  { name: 'SAMOA', code: 'WSM' },
  { name: 'SAN MARINO', code: 'SMR' },
  { name: 'SAUDI ARABIA', code: 'SAU' },
  { name: 'SENEGAL', code: 'SEN' },
  { name: 'SERBIA', code: 'SRB' },
  { name: 'SEYCHELLES', code: 'SYC' },
  { name: 'SIJERA LEONE', code: 'SLE' },
  { name: 'SINGAPORE', code: 'SGP' },
  { name: 'SLOVAKIA', code: 'SVK' },
  { name: 'SLOVENIA', code: 'SVN' },
  { name: 'SOLOMON ISLANDS', code: 'SLB' },
  { name: 'SOMALIA', code: 'SOM' },
  { name: 'SOUTH AFRICA', code: 'ZAF' },
  { name: 'SPAIN', code: 'ESP' },
  { name: 'SRI LANKA', code: 'LKA' },
  { name: 'SUDAN', code: 'SDN' },
  { name: 'SURINAM', code: 'SUR' },
  { name: 'SVALBARD AND JAN MAYEN', code: 'SJM' },
  { name: 'SVAZI', code: 'SWZ' },
  { name: 'SWEDEN', code: 'SWE' },
  { name: 'SWITZERLAND', code: 'CHE' },
  { name: 'SYRIA', code: 'SYR' },
  { name: 'TAIWAN, CHINESE', code: 'TWN' },
  { name: 'TAJIKISTAN', code: 'TJK' },
  { name: 'TANZANIA', code: 'TZA' },
  { name: 'THAILAND', code: 'THA' },
  { name: 'TIMOR LESTE', code: 'TLS' },
  { name: 'TOGO', code: 'TGO' },
  { name: 'TOKELAU', code: 'TKL' },
  { name: 'TONGA', code: 'TON' },
  { name: 'TRINIDAD AND TOBAGO', code: 'TTO' },
  { name: 'TUNISIA', code: 'TUN' },
  { name: 'TURKEY', code: 'TUR' },
  { name: 'TURKMENISTAN', code: 'TKM' },
  { name: 'TURKS AND CAICOS ISLANDS', code: 'TCA' },
  { name: 'TUVALU', code: 'TUV' },
  { name: 'UGANDA', code: 'UGA' },
  { name: 'UKRAINE', code: 'UKR' },
  { name: 'UNITED ARAB EMIRATES', code: 'ARE' },
  { name: 'UNITED STATES OF AMERICA', code: 'USA' },
  { name: 'URUGUAY', code: 'URY' },
  { name: 'UZBEKISTAN', code: 'UZB' },
  { name: 'VANUATU', code: 'VUT' },
  { name: 'VATICAN, HOLY SEE', code: 'VAT' },
  { name: 'VENEZUELA', code: 'VEN' },
  { name: 'VIETNAM', code: 'VNM' },
  { name: 'WALLIS AND FUTUNA', code: 'WLF' },
  { name: 'WESTERN SAHARA', code: 'ESH' },
  { name: 'YEMEN', code: 'YEM' },
  { name: 'ZAMBIA', code: 'ZMB' },
  { name: 'ZIMBABWE', code: 'ZWE' },
];
